<div class="card">
  <div class="card-body">
    <form [formGroup]="companyForm" (ngSubmit)="onSubmit()">
      <section class="fillvatid">
        <h4>Recommended: Fill by VAT ID</h4>
        <p>
          Please enter only the numbers of your VAT ID, without the
          country code or any initial letters.
        </p>
        <div class="row">
          <div class="input">
            <label>
              Type
            </label>
            <select id="dropdown" formControlName="companyType" (change)="changeCountryType($event)" required>
              <option value="Business" [selected]="companyInfo.companyType === 'Business'">Business</option>
              <option value="Personal" [selected]="companyInfo.companyType === 'Personal'">Personal</option>
            </select>
          </div>
          <div *ngIf="!isCompanyPersonal" class="input">
            <label>
              Registered Country
            </label>
            <select id="dropdown" formControlName="registeredCountry" required>
              <option *ngFor="let country of countries" [value]="country.name" [attr.data-iseu]="country.isEU"
                [attr.data-code]="country.code" [selected]="country.name === companyInfo.registeredCountry">
                {{ country.name }}
              </option>
            </select>
          </div>
          <div *ngIf="!isCompanyPersonal" class="input searchinput">
            <div class="input searchinput">
              <label>VAT ID / CVR / ORGANISATIONSNUMMER</label>
              <span class="searchwrap">
                <input type="text" formControlName="vatid" [disabled]="DisconnectVatID" />
                <!-- Show validate button when no valid VAT ID exists -->
                <button *ngIf="!ValidVatID || !companyForm.get('vatid')?.value" class="btn green"
                  data-action="validate-vat" (click)="validateVat()">
                  Validate and add VAT
                </button>
                <!-- Show disconnect button when VAT ID is valid -->
                <button *ngIf="ValidVatID && companyForm.get('vatid')?.value" class="btn red"
                  (click)="disconnectVatId()">
                  Disconnect VAT ID
                </button>
              </span>
            </div>
          </div>
        </div>

      </section>

      <hr class="dashed" *ngIf="!newCompany || isCompanyPersonal">

      <section class="nameofcompany" *ngIf="!newCompany || isCompanyPersonal">
        <h4>Name of company</h4>
        <p>
          The brand name serves as a simplified representation of your
          company across the platform, newsletters, and other forms of
          communication, while the legal identity is used for financial
          transactions and official matters.
        </p>
        <div class="row">
          <div class="input">
            <label>
              Brand name (used across the platform)
            </label>
            <input type="text" formControlName="brandName" [ngClass]="{'blocked': !isAdmin}">
          </div>
          <div class="input">
            <label>
              Legal Name of Company
              <img *ngIf="!isAdmin" src="assets/icons/lock.svg" alt="Locked field" />
            </label>
            <input type="text" [ngClass]="{'blocked': !isAdmin}" [disabled]="!isAdmin" formControlName="legalName" />
          </div>
        </div>
      </section>
      <hr class="dashed" *ngIf="!newCompany || isCompanyPersonal">
      <section class="addressinformation" *ngIf="!newCompany || isCompanyPersonal">
        <h4>Address information</h4>
        <div class="row">
          <div class="input">
            <label *ngIf="!isCompanyPersonal">Registered Country</label>
            <label *ngIf="isCompanyPersonal">Country</label>
            <select id="dropdown" formControlName="registeredCountry" required>
              <option *ngFor="let country of countries" [value]="country.name" [attr.data-iseu]="country.isEU">
                {{ country.name }}
              </option>
            </select>
          </div>
          <div class="input">
            <label>City<img *ngIf="!isAdmin" src="assets/icons/lock.svg" alt="Locked field" /></label>
            <input type="text" formControlName="city" [ngClass]="{'blocked': !isAdmin}">
          </div>
          <div class="input">
            <label>ZIP<img *ngIf="!isAdmin" src="assets/icons/lock.svg" alt="Locked field" /></label>
            <input type="text" formControlName="zip" [ngClass]="{'blocked': !isAdmin}">
          </div>
          <div class="input">
            <label>Address<img *ngIf="!isAdmin" src="assets/icons/lock.svg" alt="Locked field" /></label>
            <input type="text" formControlName="address" [ngClass]="{'blocked': !isAdmin}">
          </div>
        </div>
        <hr class="dashed" *ngIf="(!newCompany || isCompanyPersonal) && hasMembership">
        <section class="memberships" *ngIf="hasMembership">
          <h4>Memberships</h4>
          <p>
            Please reach out to {{ organizationId === 1 ? 'MPO' : 'Music Nest' }} if your label is incorrectly linked to
            any of the following
            organizations:
          </p>

          <article>
            <div class="ifpinorway" *ngIf="organizationId == 2 && companyInfo.ifpiNorge">
              <span><img src="assets/img/ifpinorway-favicon.png" alt="IFPI Norge"></span>
              <p>IFPI Norway</p>
            </div>

            <div class="fono" *ngIf="organizationId == 2 && companyInfo.fono">
              <span><img src="assets/img/fono-favicon.png" alt="FONO Norge"></span>
              <p>FONO</p>
            </div>
            <div class="ifpidenmark" *ngIf="organizationId == 1 && companyInfo.ifpiDanmark">
              <span><img src="assets/img/ifpidenmark.svg" alt="IFPI Denmark"></span>
              <p>IFPI Danmark</p>
            </div>
          </article>
        </section>
      </section>


    <hr class="dashed" *ngIf="!newCompany || isCompanyPersonal">
    <section class="Paymentdetails" *ngIf="!newCompany || isCompanyPersonal">
      <h4>Payment details</h4>
      <p>
        The current information which is used for distributions. To change your account please contact {{ organizationId
        === 1 ? 'MPO' : 'Music Nest' }}
      </p>

      <!-- If company is not collecting for itself, show collecting label -->
      <div *ngIf="!companyInfo.collectDirectly" class="row">
        <div class="input">
          <label>Collecting Company<img *ngIf="!isAdmin" src="assets/icons/lock.svg" alt="Locked field" /></label>
          <div class="nemkonto">
            Remuneration will be paid directly to
            <b>{{ companyInfo.collectorId ? companyInfo.collectorId : '' }}</b>
          </div>
        </div>
      </div>

      <!-- If company collects for itself, show different account number fields based on country -->
      <div *ngIf="companyInfo.collectDirectly" class="row">
        <!-- For Norway -->
        <div class="input" *ngIf="Norway && organizationId == 2">
          <label>Account Number<img src="assets/icons/lock.svg" alt="Locked field" /></label>
          <input id="inputformat-no" data-format="norwegian-account"
            formControlName="accountNumber" maxlength="14" readonly class="blocked"
            type="text" />
        </div>

        <!-- For Denmark - Show input OR NemKonto message -->
        <div *ngIf="Denmark && organizationId == 1">
          <!-- Show input fields when NOT using NemKonto -->
          <div *ngIf="!companyInfo.useNemkonto">
            <div class="row">
              <div class="input">
                <label>Registration Number<img src="assets/icons/lock.svg"
                    alt="Locked field" /></label>
                <input formControlName="registrationNumber" readonly
                  class="blocked" type="text" />
              </div>

              <div class="input">
                <label>Account Number<img src="assets/icons/lock.svg"
                    alt="Locked field" /></label>
                <input id="inputformat-dk" data-format="danish-account"
                  formControlName="accountNumber" readonly class="blocked" type="text" />
              </div>
            </div>
          </div>

          <!-- Show green infobox when using NemKonto AND VAT ID exists to be adjusted later -->
          <!-- <div class="infobox green" *ngIf="companyInfo.useNemkonto && companyInfo.vatid">
            <p>Transfers will be done to {{ companyInfo.vatid }}</p>
          </div> -->

          <!-- Show red warning when using NemKonto BUT no VAT ID -->
          <!-- <div class="infobox red" *ngIf="companyInfo.useNemkonto && !companyInfo.vatid">
            <p><strong>NO VAT ID is connected!</strong></p>
          </div> -->


          <div class="row nemkonto" *ngIf="companyInfo.useNemkonto">
            <p>
              Danish companies will receive payments through <b>NemKonto</b>. Any changes to this require prior approval
              from MPO.
            </p>
          </div>

        </div>

        <!-- For other countries - International banking fields -->
        <div class="input" *ngIf="(!Denmark && !Norway) || (Denmark && organizationId == 2) || (Norway && organizationId == 1)">
          <label>Name of Bank<img src="assets/icons/lock.svg" alt="Locked field" /></label>
          <input formControlName="bankName" readonly
            class="blocked" type="text" />
        </div>

        <div class="input" *ngIf="(!Denmark && !Norway) || (Denmark && organizationId == 2) || (Norway && organizationId == 1)">
          <label>IBAN<img src="assets/icons/lock.svg" alt="Locked field" /></label>
          <input id="inputformat-intl" data-format="iban"
            formControlName="accountNumber" readonly class="blocked" type="text" />
        </div>

        <div class="input" *ngIf="(!Denmark && !Norway) || (Denmark && organizationId == 2) || (Norway && organizationId == 1)">
          <label>Swift/BIC<img src="assets/icons/lock.svg" alt="Locked field" /></label>
          <input formControlName="swiftBic" readonly
            class="blocked" type="text" />
        </div>
      </div>
    </section>

    </form>
  </div>
</div>

<div class="unsaved-changes-alert" *ngIf="companyForm.dirty" [ngClass]="animationState">
  <p class="fw-bold mb-0">You have unsaved changes!</p>
  <button class="btn discardbtn" (click)="cancel()">Discard changes</button>
  <!-- Temporarily disabled VAT validation requirement, allow saving even if VAT ID is invalid -->
  <button class="btn green" (click)="UpdateCompany()">Save
    changes</button>
</div>


<div class="modal" [ngClass]="{'show': showVatModal}" id="vatModal">
  <div class="mw defaultmodal">
    <div class="mwrap">
      <div class="mc">
        <div class="vatvalidation">
          <!-- INITIAL VALIDATION MESSAGE -->
          <div class="fetch">
            <h2>Validating</h2>
            <hr class="dashed">
            <p>We're checking <b>your VAT ID</b> against the official European <b>VIES database</b>. Please note that
              it may <b>take a few moments</b> to receive a response.</p>
            <hr class="dashed">
            <button class="btn red" id="close-vat-modal" (click)="closeVatModal()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>